// **..product-single-accordion js start..**
$(document).ready(function(){
    $(document).on('click', '.single-product-accordion-item-title', function() {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active').siblings().find('.single-product-accordion-item-content').slideUp();
    });

    $('.add-to-cart-btn ').on('click', function(){
       if (!$("#terms").is(":checked")) {
        alert("Please agree to the terms and conditions before continuing.");
        return false; // stop further execution
        }
    });

    $('.accordion-item-title').on('click', function(){
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active');
    });

    $('.benefit-item').on('click', function(){
        $(this).addClass('active').siblings().removeClass('active');
        $(this).siblings().find('.benefits-item-body').slideUp();
        $(this).find('.benefits-item-body').slideDown();
    });

    $('.tabs-nav-item-link').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('href');
        $(this).parent().addClass('active').siblings().removeClass('active');
        $(id).show().siblings().hide();
    });

    if($(window).width() > 768) {
        $('.image-tab-left-item').on('click', function(){
            var id = $(this).data('id');
            $('#image_tab_'+id).fadeIn().siblings().hide();
            $(this).addClass('active').siblings().removeClass('active');
        });
    }
    if($(window).width() < 768) {
        $('.tab-item-top').on('click', function(){
            $(this).next().slideToggle();
            $(this).parent().toggleClass('active').siblings().removeClass('active').find('.tab-body-mobile').slideUp();
        });
    }
    
    // option change option_input
    $(document).on('change', '.option_input', function () {
        let optionName = '';
        var template = $('.template-name').val();

        $('input:radio.option_input:checked').each(function (e) {
            optionName += e != 0 ? '-' : '';
            optionName += $(this).val();
        });

        $('.variant_selector option').each(function () {
            var txt = $.trim($(this).text());
            if (txt === optionName) {
                $(this).parent().val($(this).val());
                var vid = $(this).val();
                $('#product_id').val(vid);

                var imageId = $(this).data('img-id'); // <-- get featured image ID

                // Find the slide with matching image ID
                let targetIndex = null;
                $('.single-product-featured .swiper-slide').each(function (index) {
                    let slideImageId = $(this).data('media-id'); // You need this attribute in slide

                    if (slideImageId == imageId) {
                        targetIndex = index;
                        return false; // break loop
                    }
                });

                // Update swiper if match found
                if (typeof targetIndex === 'number') {
                    fetured.slideToLoop(targetIndex);
                }

                // other logic you already had
                var id = $('.plan_input:checked').val();
                let plan = $('.input_plan:checked').val();
                var subs = $('.select-delivery-time option:selected').val();
                var price = $(this).data('price');
                var compare = $(this).data('compare');
                var stock = $(this).data('stock');
                var rate;

                var bottle = $(".variant_selector option:selected").data('id');
                var qty = $(".single-product-quantity-total-input").val();
                if (stock) {
                    $('.add-to-cart-btn').removeClass('soldout').text('Add To Cart');
                } else {
                    $('.add-to-cart-btn').addClass('soldout').text('Sold Out');
                }

                if (template == 'oil' || template == 'cbd') {

                    let qty =  parseInt($('.bundle_selector').val());
                    let totalPrice = qty * (price * 0.01);
                    let totalCompare = qty * (compare * 0.01);
                    
                    let totalDiscount = qty *  (price * 0.01);
                    let save = (totalCompare - totalPrice);
                    let totalQty = qty;

                    $('#final_price').attr('data-price', (qty * totalPrice).toFixed(2))
                    .attr('data-discount', (qty * totalDiscount).toFixed(2))
                    .attr('data-compare', (qty * totalCompare).toFixed(2));

                    $('.bundle_selector').attr('data-price', (qty * totalPrice).toFixed(2))
                    .attr('data-discount', (qty * totalDiscount).toFixed(2))
                    .attr('data-compare', (qty * totalCompare).toFixed(2));

                    let discount_3 = $('#discount_3').val();
                    discount_3 = (100 - discount_3) / 100;

                    let save3 = ( (price * 0.01) * 3) - (((price * 0.01) * 3) * discount_3);
                    $('.step-3 .step-discount').text('Get ' + currency + save3.toFixed() + ' OFF');
                    // console.log('save3 ' + save3); 

                    priceUpdateInfo(totalPrice, totalDiscount , totalCompare, save, totalQty);

                    
                } else {
                    rate = $('.plan_input:checked').data('rate');
                    option_change(id, subs, price, compare, rate, bottle, template);
                }
            }
        });

        
    });


    // variant option 
    $(document).on('click', '.variant_option', function() {
        var vid = $(this).val();
        $('#product_id').val(vid);
        var template = $('.template-name').val();
        let variantName = $(this).data('name');

        $('.variant_selector option').each(function(){
            var txt = $.trim($(this).text());
            if(txt == variantName ){
                $(this).parent().val($(this).val()); 

                var id = $('.plan_input:checked').val(); 
                var subs = $('.select-delivery-time option:selected').val();
                var price = $(this).data('price');
                var compare = $(this).data('compare');
                var stock = $(this).data('stock');
                var rate = $('.plan_input:checked').data('rate');
                var bottle = $(".variant_selector option:selected").data('id');
                if (stock) {
                    $('.add-to-cart-btn').removeClass('soldout').text('Add To Cart');
                }else {
                    $('.add-to-cart-btn').addClass('soldout').text('Sold Out');
                }
                option_change(id, subs, price, compare, rate, bottle, template);
            }  

        }); 
    });

    // quantity plus 
    $(document).on('click', '.qty_plus', function() {
        var qty = parseInt($(this).prev().val());
        qty++;
        $(this).prev().val(qty);
        var input = $('#quanity_input_1');
        let price = input.data('price');
        let compare = input.data('compare');
        let rate = input.data('rate');
        let plan = $('.input_plan:checked').val();
        priceUpdate(price, compare, rate, plan, qty);
    });
     // quantity minus 
     $(document).on('click', '.qty_minus', function() {
        var qty = parseInt($(this).next().val());
        if( qty > 1) {
          qty--;
          $(this).next().val(qty);
          var input = $('#quanity_input_1');
          let price = input.data('price');
          let compare = input.data('compare');
          let rate = input.data('rate');
          let plan = $('.input_plan:checked').val();
          priceUpdate(price, compare, rate, plan, qty);
        }
    });

    initializeSwiper();

    // slide text 
    var swiper = new Swiper(".textSlider", {
        spaceBetween: 0,
        slidesPerView: 6,
        grabCursor: true,
        loop: true,
        a11y: false,
        freeMode: true,
        speed: 10000,
        autoplay: {
            delay: 0.5,
            disableOnInteraction: true,
        },
        breakpoints: {
            1: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });

    // brands slider 
    var swiper = new Swiper('.brandSlide',{
        spaceBetween: 0,
        grabCursor: true,
        a11y: false,
        freeMode: true,
        speed: 10000,
        loop: true,
        slidesPerView: 6,
        autoplay: {
            delay: 0.5,
            disableOnInteraction: false,
        },
        breakpoints: {
            1: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 6,
            }
        }
    });

    // before after 
    var swiper = new Swiper(".beforeAfter", {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    var swiper = new Swiper(".banner-slider", {
        slidesPerView: 1,
        grabCursor: true,
        loop: true,
        speed: 1000,
        // autoplay: {
        //     delay: 7000,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            1: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            576: {
                slidesPerView: 1,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 1,
            }
        }
    });
   
    var swiper = new Swiper(".best-sellers", {
        slidesPerView: 4,
        spaceBetween: 20,
        grabCursor: false,
        loop: false,
        speed: 500,
        autoplay: {
            // delay: 2500,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            1: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 4,
            }
        }
    });
    // best seller slider js end--
    
    // review slider js start--
    var swiper = new Swiper(".review-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        grabCursor: true,
        loop: true,
        speed: 1500,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        breakpoints: {
            // when window width is >= 320px
            1: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 767px
            767: {
                slidesPerView: 3,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 4,
            }
        }
    });
    // review slider js end--
    
    // blog slider js start--
    var swiper = new Swiper(".blog-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        grabCursor: true,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            1: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            576: {
                slidesPerView: 2,
            },
            // when window width is >= 767px
            767: {
                slidesPerView: 3,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 4,
            }
        }
    });
    // blog slider js end--
    // smooth scroll 
  $(".media-text-btn").click(function(e) {
        e.preventDefault();
        var id = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(id).offset().top
        }, 1000);
    });
})
var thumb;
var fetured;
// product image slider 
function initializeSwiper() {
    thumb = new Swiper(".single-product-thumb", {
        loop: true,
        spaceBetween: 6,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
    });

    fetured = new Swiper(".single-product-featured", {
        loop: true,
        spaceBetween: 10,
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        thumbs: {
        swiper: thumb,
        },
    });
}

 
$(document).ready(function(){
	$('.quanity-input').on('change', function(){
		var qty = $(this).val();
        let price = $(".variant_selector option:selected").data('price');
        let compare = $(".variant_selector option:selected").data('compare');
        let rate = $(this).data('rate');
        let plan = $('.input_plan:checked').val();
        // let rate = $('.plan_input').data('rate');
        priceUpdate(price, compare, rate, plan, qty);
		$('.single-product-quantity-total-input').val(qty);
	})

    $(document).on('change', '.input_plan', function() {
        $(this).parent().addClass('active').siblings().removeClass('active');
        var id = $(this).val();
        var input = $('#quanity_input_3');
        var qty = $('.single-product-quantity-total-input').val();
        let price = $(".variant_selector option:selected").data('price');
        let compare = $(".variant_selector option:selected").data('compare');
        let rate = input.data('rate');
        let plan = id;
        // let rate = $('.plan_input').data('rate');
        priceUpdate(price, compare, rate, plan, qty);

        var subs = $('.select-delivery-time option:selected').val();
        if(id == 1) {
            $('#selling_plan').val(subs);
            // $('.total-value, .value_price').show();
        }else{
            $('#selling_plan').val('');
            // $('.total-value, .value_price').hide();
        }
    })
})

function priceUpdate(price, compare, rate, plan, qty) {

    let final_price = (price * 0.01 * rate);
    final_price = (final_price * qty).toFixed(2);
    price = (price * qty);
    price = (price * 0.01).toFixed(2);
    compare = (compare * qty);
    compare = (compare * 0.01).toFixed(2);

    if(qty >= 3) {
        $('.subs_price').text(currency + (final_price * 0.7).toFixed(2));
        $('.onetime_price').text(currency + (price * 0.7).toFixed(2));
        if(compare > price) {
            var save = compare - (final_price * 0.7);
        }else{
            var save = price - (final_price * 0.7);
        }
        $('.fixed_discount').text('Save ' + currency + save.toFixed());
    }else{
        $('.subs_price').text(currency + final_price);
        $('.onetime_price').text(currency + price);

        if(compare > price) {
            var save = (compare - final_price).toFixed();
        }else{
            var save = (price - final_price).toFixed();
        }

        $('.fixed_discount').text('Save '+ currency + save);
    }

    if(plan == 1) {
        if(qty >= 3) {
            $('.reg_cost').text(currency + (final_price * 0.7).toFixed(2));
        }else{
            $('.reg_cost').text(currency + final_price);
        }
        $('.total-value').show();
        if(compare > 0) {
            $('.value_price').show().text(currency + compare);
        }else{
            $('.value_price').show().text(currency + price);
        }
        $('.subscribe-text').addClass('show').removeClass('hide');
        $('.onetime-text').removeClass('show').addClass('hide');
    }else{
        $('.subscribe-text').addClass('hide').removeClass('show');
        $('.onetime-text').removeClass('hide').addClass('show');
        if(compare > price) {
            $('.total-value').show();
            $('.value_price').show().text(currency + compare);
        }else{
            $('.value_price').hide();
            $('.total-value').hide();
        }

        if(qty >= 3) {
            $('.reg_cost').text(currency + (price * 0.7).toFixed(2));
            $('.total-value').show();
            $('.value_price').show().text(currency + price);
        }else{
            $('.reg_cost').text(currency + price);
        }
    }

    if (qty == 2) {
        $('.quanity-input').prop('checked', false).removeAttr('checked');
    } else if (qty >= 3) {
        $('.quanity-input').prop('checked', false); // Uncheck all first
        $('#quanity_input_3').prop('checked', true).attr('checked', 'checked');
    } else if (qty === 1) {
        $('.quanity-input').prop('checked', false); // Uncheck all first
        $('#quanity_input_1').prop('checked', true).attr('checked', 'checked');
    }    
    
}
